import cn from '@/utils/cn';
import React, { HTMLAttributes } from 'react';

const DEFAULT_ROWS = 4;

interface TextAreaProps extends HTMLAttributes<HTMLTextAreaElement> {
  rows?: number;
  placeholder?: string;
  value: string;
  onTextChange: (value: string) => void;
  maxAllowedCharacters?: number;
}

const TextArea: React.FC<TextAreaProps> = ({
  rows,
  className,
  placeholder,
  value,
  onTextChange,
  maxAllowedCharacters
}) => {
  return (
    <div className="relative">
      <textarea
        rows={rows ?? DEFAULT_ROWS}
        className={cn(
          'rounded-lg w-full border-dark-navy-30 focus:border-emerge-teal focus:ring-0 resize-none',
          className
        )}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onTextChange(e.target.value)}
      />
      {maxAllowedCharacters ? (
        <div className="absolute bottom-3 right-2 text-xs text-dark-base-90">
          {value.length}/{maxAllowedCharacters}
        </div>
      ) : null}
    </div>
  );
};

export default TextArea;
